<template>
  <!-- Un mòbil fet amb HTML: uns apunts pujats a apren.ai convertits en pòdcast, flashcards i test (abans, un exercici corregit) -->
  <div class="aph" aria-hidden="true">
    <div class="aph-screen">
      <div class="aph-bar"><span class="aph-logo">a</span><b>apren.ai</b></div>
      <div class="aph-file"><span class="aph-file-i">PDF</span><span class="aph-file-n">{{ t.file }}</span></div>
      <div class="aph-tag">✨ {{ t.made }}</div>
      <div class="aph-pod">
        <span class="aph-play">▶</span>
        <div class="aph-pod-r">
          <b>{{ t.podcast }}</b>
          <div class="aph-wave"><i v-for="(h, k) in wave" :key="k" :style="{ height: h + 'px' }" :class="{ on: k < 7 }"></i></div>
        </div>
      </div>
      <div class="aph-row">🃏 <b>{{ t.cards }}</b></div>
      <div class="aph-row">✅ <b>{{ t.test }}</b></div>
      <div class="aph-next">{{ t.next }}</div>
    </div>
  </div>
</template>

<script>
const TEXTS = {
  ca: { file: 'Tema 3 · La cèl·lula.pdf', made: 'Creat amb IA', podcast: 'Pòdcast · 8 min', cards: '24 flashcards', test: 'Test · 15 preguntes', next: 'Escolta’l ara →' },
  es: { file: 'Tema 3 · La célula.pdf', made: 'Creado con IA', podcast: 'Pódcast · 8 min', cards: '24 flashcards', test: 'Test · 15 preguntas', next: 'Escúchalo ya →' },
};
export default {
  name: 'AprenAiPhone',
  props: { lang: { type: String, default: 'ca' } },
  data: () => ({ wave: [5, 9, 6, 12, 8, 14, 7, 10, 5, 11, 7, 9, 4, 8] }),
  computed: { t() { return TEXTS[this.lang] || TEXTS.ca; } },
};
</script>

<style scoped>
.aph { width: 150px; flex: 0 0 auto; border-radius: 26px; background: #111; padding: 7px; box-shadow: 0 12px 28px rgba(0, 0, 0, .3); transform: rotate(-5deg);
  font-family: 'Rubik', system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif; }
.aph-screen { background: #fff; border-radius: 20px; padding: 10px 9px 12px; display: flex; flex-direction: column; gap: 6px; min-height: 230px; text-align: left; }
.aph-bar { display: flex; align-items: center; gap: 5px; font-size: 11px; color: #111; }
.aph-logo { width: 18px; height: 18px; border-radius: 6px; background: #4ed452; color: #fff; font-weight: 800; display: flex; align-items: center; justify-content: center; font-size: 11px; }
.aph-file { display: flex; align-items: center; gap: 5px; border: 1.5px dashed #c7d2c5; border-radius: 8px; padding: 4px 5px; }
.aph-file-i { flex: 0 0 auto; background: #e5484d; color: #fff; font-size: 7px; font-weight: 800; border-radius: 3px; padding: 2px 3px; }
.aph-file-n { font-size: 9px; color: #374151; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.aph-tag { font-size: 9px; font-weight: 800; color: #1f9d2e; letter-spacing: .04em; text-transform: uppercase; }
.aph-pod { display: flex; align-items: center; gap: 6px; background: #f3f0ff; border: 1.5px solid #ddd5fb; border-radius: 9px; padding: 5px 6px; }
.aph-play { flex: 0 0 20px; height: 20px; border-radius: 50%; background: #6d4aff; color: #fff; font-size: 8px; display: flex; align-items: center; justify-content: center; }
.aph-pod-r { display: flex; flex-direction: column; gap: 3px; min-width: 0; }
.aph-pod-r b { font-size: 9.5px; color: #3b2a8f; }
.aph-wave { display: flex; align-items: center; gap: 2px; height: 14px; }
.aph-wave i { width: 2px; border-radius: 2px; background: #cbbffb; }
.aph-wave i.on { background: #6d4aff; }
.aph-row { font-size: 10px; color: #1f2937; background: #f3fdf2; border: 1.5px solid #d3f0cf; border-radius: 8px; padding: 4px 6px; }
.aph-next { margin-top: auto; background: #0d3b10; color: #fff; border-radius: 8px; padding: 6px; font-size: 10px; font-weight: 700; text-align: center; }
</style>
